import React, { useState } from 'react'
import { useSnackbar } from 'notistack'
import { useForm } from 'react-hook-form'
import { useStyles } from './FormAdresseStyle'
import AdresseAutoComplete from '../../AdresseAutoComplete/AdresseAutoComplete'
import SelectPays from '../../SelectPays/SelectPays'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../../../redux/actions/user'
import TabNavigation from '../../TabNavigation/TabNavigation'

//Material UI
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'


export default function FormAdresse(props) {

  const dispatch = useDispatch()
  const classes = useStyles()
  const { formClass, defaultValues, refresh, pays, adresseTypes, postCodes, id, nextTab, previousTab } = props
  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''
  const { register, handleSubmit } = useForm()
  const { enqueueSnackbar } = useSnackbar()
  const [prefixe, setPrefixe] = useState(defaultValues?.prefixe ?? '')
  const [adresseType, setAdresseType] = useState(defaultValues?.adresseType ?? '')
  const [adresse, setAdresse] = useState({ nom: defaultValues?.ville, code: defaultValues?.codePostal })


  async function save(data, e) {

    data = { ...data, category: 2, prefixe, adresseType, codePostal: adresse.code , ville: adresse.nom }
    const result = await allActions.fetchPostAPI(`api/users/modifs-infos-perso/${id}`, data, dispatch, token)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
      return
    }

    //Si le serveur retourne une erreur elle est affiché
    if (result?.json.err) {
      enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
      return
    }

    enqueueSnackbar('Enregistré !', { variant: `success` })
    refresh(result.json.data)

    const action = e.nativeEvent.submitter.dataset.action
    if (action === 'previous' && previousTab) previousTab()
    else if (action === 'next') nextTab()
  }

  return (
    <form onSubmit={handleSubmit(save)}>
      <div className={formClass}>

        <div className={classes.formLine}>
          <TextField
            label="Numéro"
            variant="outlined"
            type="number"
            name="adresseNum"
            margin="dense"
            inputRef={register}
            required
            style={{ width: '100px' }}
            defaultValue={defaultValues?.adresseNum}
          />

          <TextField
            select
            label=" "
            variant="outlined"
            value={prefixe}
            onChange={(e) => setPrefixe(e.target.value)}
            margin="dense"

          >
            <MenuItem value=""></MenuItem>
            <MenuItem value="Bis">Bis</MenuItem>
            <MenuItem value="Ter">Ter</MenuItem>
          </TextField>
          <TextField
            select
            label=" "
            variant="outlined"
            value={adresseType}
            onChange={(e) => setAdresseType(e.target.value)}
            margin="dense"
            required
          >
            {adresseTypes.map((a, i) => (<MenuItem value={a.id} key={i}>{a.libelle}</MenuItem>))}
          </TextField>
        </div>
        <TextField
          label="Ligne 1"
          variant="outlined"
          type="text"
          name="adresseL1"
          margin="dense"
          inputProps={{ style: { textTransform: "lowercase" } }}
          inputRef={register}
          required
          defaultValue={defaultValues?.adresseL1}
        />
        <TextField
          label="ligne 2"
          variant="outlined"
          type="text"
          inputProps={{ style: { textTransform: "lowercase" } }}
          name="adresseL2"
          margin="dense"
          inputRef={register}
          defaultValue={defaultValues?.adresseL2}
        />

        <div className={classes.formLineTwo}>
          <TextField
            label="Bâtiment"
            variant="outlined"
            type="text"
            name="batiment"
            margin="dense"
            inputRef={register}
            defaultValue={defaultValues?.batiment}
          />
          <TextField
            label="Escalier"
            variant="outlined"
            type="text"
            name="escalier"
            margin="dense"
            inputRef={register}
            defaultValue={defaultValues?.escalier}
          />
        </div>

        <AdresseAutoComplete
          register={register}
          required={true}
          value={adresse}
          setValue={setAdresse}
          postCodes={postCodes}
        />

        <SelectPays
          register={register}
          label="Pays"
          defaultValue={defaultValues?.pays}
          pays={pays}
          setPays={(e) => e}
        />

      </div>

      <TabNavigation save previous next/>
    </form>
  )
}
